import React from "react";

interface StringCellProps {
  value: any;
}

/**
 * Truncated string cell renderer (medonc StringCell parity).
 *
 * @param props - Cell value to display
 * @returns Truncated text cell
 */
export const StringCell: React.FC<StringCellProps> = ({ value }) => {
  return (
    <div title={value} className="w-full truncate">
      {value}
    </div>
  );
};

export default StringCell;
